var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECKOUT_FRAGMENT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const appliedGiftCardFragment_1 = require("./appliedGiftCardFragment");
const mailingAddressFragment_1 = require("./mailingAddressFragment");
const variantWithProductFragment_1 = require("./variantWithProductFragment");
exports.CHECKOUT_FRAGMENT = (0, graphql_tag_1.default) `
  fragment CheckoutFragment on Checkout {
    id
    ready
    requiresShipping
    note
    paymentDueV2 {
      amount
      currencyCode
    }
    webUrl
    orderStatusUrl
    taxExempt
    taxesIncluded
    currencyCode
    totalTax
    totalTaxV2 {
      amount
      currencyCode
    }
    lineItemsSubtotalPrice {
      amount
      currencyCode
    }
    subtotalPriceV2 {
      amount
      currencyCode
    }
    totalPriceV2 {
      amount
      currencyCode
    }
    completedAt
    createdAt
    updatedAt
    email
    appliedGiftCards {
      ...AppliedGiftCardFragment
    }
    shippingAddress {
      ...MailingAddressFragment
    }
    shippingLine {
      handle
      price
      title
    }
    customAttributes {
      key
      value
    }
    order {
      id
      processedAt
      orderNumber
      subtotalPriceV2 {
        amount
        currencyCode
      }
      totalShippingPrice
      totalShippingPriceV2 {
        amount
        currencyCode
      }
      totalTaxV2 {
        amount
        currencyCode
      }
      totalPriceV2 {
        amount
        currencyCode
      }
      currencyCode
      totalRefunded
      totalRefundedV2 {
        amount
        currencyCode
      }
      customerUrl
      shippingAddress {
        ...MailingAddressFragment
      }
      lineItems(first: 250) {
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
        edges {
          cursor
          node {
            title
            variant {
              ...VariantWithProductFragment
            }
            quantity
            customAttributes {
              key
              value
            }
          }
        }
      }
    }
    lineItems(first: 250) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          title
          variant {
            ...VariantWithProductFragment
          }
          quantity
          customAttributes {
            key
            value
          }
          discountAllocations {
            allocatedAmount {
              amount
              currencyCode
            }
          }
        }
      }
    }
    discountApplications(first: 10) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          ... on DiscountCodeApplication {
            code
          }
          allocationMethod
          targetSelection
          targetType
          value {
            ... on PricingPercentageValue {
              percentage
            }
            ... on MoneyV2 {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
  ${appliedGiftCardFragment_1.APPLIED_GIFT_CARD_FRAGMENT}
  ${mailingAddressFragment_1.MAILING_ADDRESS_FRAGMENT}
  ${variantWithProductFragment_1.VARIANT_WITH_PRODUCT_FRAGMENT}
`;
//# sourceMappingURL=checkoutFragment.js.map